import Typography from '@mui/material/Typography'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { Accordion } from '@/components/Inputs'
import Box from '@mui/material/Box'

interface Card {
    question?: string
    answer?: string
}

interface Content {
    title?: string
    subtitle?: string
    cards?: Card[]
}

interface S2_Hero_6Props {
    content?: Content
    blockName?:string
}

const Index = (props: S2_Hero_6Props) => {
    const { content } = props
    const { title, subtitle, cards = [] } = content || {}
    return (
        <RegularSection aria-label='S2_Hero_6' >
            <ColorTitle
                title={title}
                colorFrom={1}
            />
            <Typography
                variant='body2'
                sx={{ textAlign: 'center', width: { xs: '90vw', md: '80vw' } }}
            >
                {subtitle}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: { xs: '90vw', md: '60vw' } }}>
                {cards.map((card, index) => (
                    <Accordion
                        key={'faq-item' + index}
                        title={card?.question}
                        subtitle={card?.answer}
                        expanded={index === 0}
                    />
                ))}
            </Box>
        </RegularSection>
    )
}

export default Index
